import { BhmsConfigType } from "../../bhms/bhms_config";

function getPossibleKeys(final_count: number) {
  const grid_bank_count_list: string[] = [];
  for (let i = 1; i <= final_count; i++) {
    grid_bank_count_list.push("B" + i);
  }

  return [grid_bank_count_list, "IBAT", "VBAT"];
}

export const TOTAL_POSSIBLE_PM_KEYS = getPossibleKeys(11);
const TOTAL_POSSIBLE_CYZ_KEYS = getPossibleKeys(12);

const TOTAL_POSSIBLE_CELL_KEYS = [
  [
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "B10",
    "B11",
    "B12",
    "B13",
    "B14",
    "B15",
    "B16",
    "B17",
    "B18",
    "B19",
    "B20",
    "B21",
    "B22",
    "B23",
    "B24",
    "B25",
    "B26",
    "B27",
    "B28",
    "B29",
    "B30",
    "B31",
    "B32",
    "B33",
    "B34",
    "B35",
    "B36",
    "B37",
    "B38",
    "B39",
    "B40",
    "B41",
    "B42",
    "B43",
    "B44",
    "B45",
    "B46",
    "B47",
    "B48",
    "B49",
    "B50",
    "B51",
    "B52",
    "B53",
    "B54",
    "B55",
  ],
  "VBAT",
];
export const FIXED_VIRTUAL_SPACE_FOR_EACH_KEY = 200;
export const FIXED_VIRTUAL_BUFFER_BETWEEN_KEYS = 40;
export const KEYS_TO_BE_FORMATTED = ["S", "A", "V"];

export function getBHMSHistoryConfig(type: BhmsConfigType = BhmsConfigType.grid) {
  switch (type) {
    case BhmsConfigType.cyz_grid: {
      return {
        TOTAL_POSSIBLE_PM_KEYS: TOTAL_POSSIBLE_CYZ_KEYS,
        STATIC_KEYS_INFO: STATIC_CYZ_KEYS_INFO,
      };
    }
    case BhmsConfigType.grid: {
      return {
        TOTAL_POSSIBLE_PM_KEYS,
        STATIC_KEYS_INFO,
      };
    }
    case BhmsConfigType.cell: {
      return {
        TOTAL_POSSIBLE_PM_KEYS: TOTAL_POSSIBLE_CELL_KEYS,
        STATIC_KEYS_INFO: CELL_KEYS_INFO,
      };
    }
  }
}

export const STATIC_CYZ_KEYS_INFO: any = {
  B1: {
    key: "B1",
    label: "B1",
    lineColor: "#FCD05E",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B2: {
    key: "B2",
    label: "B2",
    lineColor: "#3f51b5",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B3: {
    key: "B3",
    label: "B3",
    lineColor: "blue",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B4: {
    key: "B4",
    label: "B4",
    lineColor: "#e51c23",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B5: {
    key: "B5",
    label: "B5",
    lineColor: "#00876c",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B6: {
    key: "B6",
    label: "B6",
    lineColor: "#65b17a",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B7: {
    key: "B7",
    label: "B7",
    lineColor: "#ef8251",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B8: {
    key: "B8",
    label: "B8",
    lineColor: "#d43d51",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B9: {
    key: "B9",
    label: "B9",
    lineColor: "#e91e63",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B10: {
    key: "B10",
    label: "B10",
    lineColor: "#9c27b0",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B11: {
    key: "B11",
    label: "B11",
    lineColor: "#673ab7",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B12: {
    key: "B12",
    label: "B12",
    lineColor: "#673ab7",
    actualUnitsForYaxis: 20,
    unit: "V",
    box_label: "B1 - B12",
  },
  IBANK: {
    key: "IBANK",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBANK: {
    key: "VBANK",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  IBAT: {
    key: "IBAT",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBAT: {
    key: "VBAT",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  RWV: {
    key: "RWV",
    label: "Reverse Operation Voltage",
    lineColor: "#404040",
    actualUnitsForYaxis: 160,
    unit: "V",
  },
};

const STATIC_KEYS_INFO: any = {
  B1: {
    key: "B1",
    label: "B1",
    lineColor: "#FCD05E",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B2: {
    key: "B2",
    label: "B2",
    lineColor: "#3f51b5",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B3: {
    key: "B3",
    label: "B3",
    lineColor: "blue",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B4: {
    key: "B4",
    label: "B4",
    lineColor: "#e51c23",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B5: {
    key: "B5",
    label: "B5",
    lineColor: "#00876c",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B6: {
    key: "B6",
    label: "B6",
    lineColor: "#65b17a",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B7: {
    key: "B7",
    label: "B7",
    lineColor: "#ef8251",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B8: {
    key: "B8",
    label: "B8",
    lineColor: "#d43d51",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B9: {
    key: "B9",
    label: "B9",
    lineColor: "#e91e63",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B10: {
    key: "B10",
    label: "B10",
    lineColor: "#9c27b0",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B11: {
    key: "B11",
    label: "B11",
    lineColor: "#673ab7",
    actualUnitsForYaxis: 20,
    unit: "V",
    box_label: "B1 - B11",
  },
  IBANK: {
    key: "IBANK",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBANK: {
    key: "VBANK",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  IBAT: {
    key: "IBAT",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBAT: {
    key: "VBAT",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  RWV: {
    key: "RWV",
    label: "Reverse Operation Voltage",
    lineColor: "#404040",
    actualUnitsForYaxis: 160,
    unit: "V",
  },
};

const CELL_KEYS_INFO = {
  B1: {
    key: "B1",
    label: "B1",
    lineColor: "#FCD05E",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B2: {
    key: "B2",
    label: "B2",
    lineColor: "#3f51b5",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B3: {
    key: "B3",
    label: "B3",
    lineColor: "blue",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B4: {
    key: "B4",
    label: "B4",
    lineColor: "#e51c23",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B5: {
    key: "B5",
    label: "B5",
    lineColor: "#00876c",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B6: {
    key: "B6",
    label: "B6",
    lineColor: "#65b17a",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B7: {
    key: "B7",
    label: "B7",
    lineColor: "#ef8251",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B8: {
    key: "B8",
    label: "B8",
    lineColor: "#d43d51",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B9: {
    key: "B9",
    label: "B9",
    lineColor: "#e91e63",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B10: {
    key: "B10",
    label: "B10",
    lineColor: "#9c27b0",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B11: {
    key: "B11",
    label: "B11",
    lineColor: "#673ab7",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B12: {
    key: "B12",
    label: "B12",
    lineColor: "#673ab7",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B13: {
    key: "B13",
    label: "B13",
    lineColor: "#3f51b5",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B14: {
    key: "B14",
    label: "B14",
    lineColor: "#5677fc",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B15: {
    key: "B15",
    label: "B15",
    lineColor: "#03a9f4",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B16: {
    key: "B16",
    label: "B16",
    lineColor: "#00bcd4",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B17: {
    key: "B17",
    label: "B17",
    lineColor: "#009688",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B18: {
    key: "B18",
    label: "B18",
    lineColor: "#259b24",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B19: {
    key: "B19",
    label: "B19",
    lineColor: "#8bc34a",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B20: {
    key: "B20",
    label: "B20",
    lineColor: "#afb42b",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B21: {
    key: "B21",
    label: "B21",
    lineColor: "#ff9800",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B22: {
    key: "B22",
    label: "B22",
    lineColor: "#ff5722",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B23: {
    key: "B23",
    label: "B23",
    lineColor: "#795548",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B24: {
    key: "B24",
    label: "B24",
    lineColor: "#607d8b",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B25: {
    key: "B25",
    label: "B25",
    lineColor: "#FF6633",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B26: {
    key: "B26",
    label: "B26",
    lineColor: "#FFB399",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B27: {
    key: "B27",
    label: "B27",
    lineColor: "#FF33FF",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B28: {
    key: "B28",
    label: "B28",
    lineColor: "#00B3E6",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B29: {
    key: "B29",
    label: "B29",
    lineColor: "#E6B333",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B30: {
    key: "B30",
    label: "B30",
    lineColor: "#3366E6",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B31: {
    key: "B31",
    label: "B31",
    lineColor: "#999966",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B32: {
    key: "B32",
    label: "B32",
    lineColor: "#B34D4D",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B33: {
    key: "B33",
    label: "B33",
    lineColor: "#80B300",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B34: {
    key: "B34",
    label: "B34",
    lineColor: "#809900",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B35: {
    key: "B35",
    label: "B35",
    lineColor: "#E6B3B3",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B36: {
    key: "B36",
    label: "B36",
    lineColor: "#6680B3",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B37: {
    key: "B37",
    label: "B37",
    lineColor: "#66991A",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B38: {
    key: "B38",
    label: "B38",
    lineColor: "#FF99E6",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B39: {
    key: "B39",
    label: "B39",
    lineColor: "#FF1A66",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B40: {
    key: "B40",
    label: "B40",
    lineColor: "#E6331A",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B41: {
    key: "B41",
    label: "B41",
    lineColor: "#33FFCC",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B42: {
    key: "B42",
    label: "B42",
    lineColor: "#66994D",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B43: {
    key: "B43",
    label: "B43",
    lineColor: "#B366CC",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B44: {
    key: "B44",
    label: "B44",
    lineColor: "#4D8000",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B45: {
    key: "B45",
    label: "B45",
    lineColor: "#B33300",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B46: {
    key: "B46",
    label: "B46",
    lineColor: "#CC80CC",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B47: {
    key: "B47",
    label: "B47",
    lineColor: "#66664D",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B48: {
    key: "B48",
    label: "B48",
    lineColor: "#991AFF",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B49: {
    key: "B49",
    label: "B49",
    lineColor: "#E666FF",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B50: {
    key: "B50",
    label: "B50",
    lineColor: "#4DB3FF",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B51: {
    key: "B51",
    label: "B51",
    lineColor: "#1AB399",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B52: {
    key: "B52",
    label: "B52",
    lineColor: "#E666B3",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B53: {
    key: "B53",
    label: "B53",
    lineColor: "#33991A",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B54: {
    key: "B54",
    label: "B54",
    lineColor: "#CC9999",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  B55: {
    key: "B55",
    label: "B55",
    lineColor: "#B3B31A",
    actualUnitsForYaxis: 20,
    unit: "V",
  },
  IBAT: {
    key: "IBAT",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBAT: {
    key: "VBAT",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  IBANK: {
    key: "IBANK",
    label: "IBank",
    lineColor: "#7BB367",
    actualUnitsForYaxis: 80,
    custom_range: { min: -40, max: 40 },
    unit: "A",
  },
  VBANK: {
    key: "VBANK",
    label: "VBank",
    lineColor: "#117BA8",
    actualUnitsForYaxis: 150,
    unit: "V",
  },
  RWV: {
    key: "RWV",
    label: "Reverse Operation Voltage",
    lineColor: "#404040",
    actualUnitsForYaxis: 160,
    unit: "V",
  },
};

export const DUMMY_POINT_RESPONSE = [
  //   {
  //     createdTs: 1703577428156,
  //     data: {
  //       STN: "AELN",
  //       VER: "1.0",
  //       LOC: "SER",
  //       DATE: "04-01-00",
  //       TIME: "22-23-25",
  //       TEMP: "0",
  //       RH: "0",
  //       RSSI: "0",
  //       NAME: "100A",
  //       GEARTYPE: "PM",
  //       SUBGEAR: "PMO",
  //       EVENTTYPE: "4",
  //       OC: "2200",
  //       PC: "4000",
  //       OT: "2552",
  //       EVENTTIME: [
  //         0, 24, 47, 70, 94, 117, 141, 164, 187, 211, 234, 258, 281, 305, 328, 351, 375, 398, 422, 445, 468, 492, 515,
  //         539, 562, 585, 609, 632, 656, 679, 703, 726, 749, 773, 796, 820, 843, 866, 890, 913, 937, 960, 984, 1007, 1030,
  //         1054, 1077, 1101, 1124, 1147, 1171, 1194, 1218, 1241, 1265, 1288, 1311, 1335, 1358, 1382, 1405, 1428, 1452,
  //         1475, 1499, 1522, 1545, 1569, 1592, 1616, 1639, 1663, 1686, 1709, 1733, 1756, 1780, 1803, 1826, 1850, 1873,
  //         1897, 1920, 1944, 1967, 1990, 2014, 2037, 2061, 2084, 2107, 2131, 2154, 2178, 2201, 2224, 2248, 2271, 2295,
  //         2318, 2342, 2552, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //       ],
  //       EVENTDATA1: [
  //         0, 262, 262, 275, 275, 275, 287, 287, 300, 300, 300, 312, 312, 312, 325, 325, 337, 337, 337, 350, 350, 350, 362,
  //         362, 362, 375, 375, 375, 387, 387, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400,
  //         400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400,
  //         400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 387, 387, 387, 375,
  //         375, 375, 362, 362, 362, 350, 350, 337, 337, 337, 325, 325, 287, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0,
  //       ],
  //       PARENT_DEVICE: "AELN_PM_100A",
  //       NWV: "112000",
  //       RWV: "108000",
  //     },
  //     tsCategoryId: 45,
  //   },
  //   {
  //     createdTs: 1703577438156,
  //     data: {
  //       STN: "AELN",
  //       VER: "1.0",
  //       LOC: "SER",
  //       DATE: "04-01-00",
  //       TIME: "22-23-25",
  //       TEMP: "0",
  //       RH: "0",
  //       RSSI: "0",
  //       NAME: "100A",
  //       GEARTYPE: "PM",
  //       SUBGEAR: "PMO",
  //       EVENTTYPE: "4",
  //       OC: "2300",
  //       PC: "4100",
  //       OT: "3052",
  //       EVENTTIME: [
  //         0, 24, 47, 70, 94, 117, 141, 164, 187, 211, 234, 258, 281, 305, 328, 351, 375, 398, 422, 445, 468, 492, 515,
  //         539, 562, 585, 609, 632, 656, 679, 703, 726, 749, 773, 796, 820, 843, 866, 890, 913, 937, 960, 984, 1007, 1030,
  //         1054, 1077, 1101, 1124, 1147, 1171, 1194, 1218, 1241, 1265, 1288, 1311, 1335, 1358, 1382, 1405, 1428, 1452,
  //         1475, 1499, 1522, 1545, 1569, 1592, 1616, 1639, 1663, 1686, 1709, 1733, 1756, 1780, 1803, 1826, 1850, 1873,
  //         1897, 1920, 1944, 1967, 1990, 2014, 2037, 2061, 2084, 2107, 2131, 2154, 2178, 2201, 2224, 2248, 2271, 2295,
  //         2318, 2342, 2552, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //       ],
  //       EVENTDATA1: [
  //         0, 262, 262, 275, 275, 275, 287, 287, 300, 300, 300, 312, 312, 312, 325, 325, 337, 337, 337, 350, 350, 350, 362,
  //         362, 362, 375, 375, 375, 387, 387, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400,
  //         400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400,
  //         400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 400, 387, 387, 387, 375,
  //         375, 375, 362, 362, 362, 350, 350, 337, 337, 337, 325, 325, 287, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //         0, 0, 0, 0, 0, 0, 0, 0,
  //       ],
  //       PARENT_DEVICE: "AELN_PM_100A",
  //       NWV: "110000",
  //       RWV: "109000",
  //     },
  //     tsCategoryId: 45,
  //   },
];

export const DUMMY_RES = [
  {
    data: [
      {
        subGear: "SB2",
        dateTime: 1707919733589,
        classification: null,
        values: {
          LOC: "IPSROOM",
          B2: 4000,
          B3: 11000,
          B4: 3000,
          B10: 6051,
          B11: 11021,
          B12: 121903,
          B13: "***",
          B14: "***",
          B15: "***",
          B16: "***",
          STN: "VS",
          NAME: "BATT2",
          B9: 10899,
          SUBGEAR: "SB2",
          GEARTYPE: "BAT",
          IBAT: -11000,
          VBAT: 70000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB1",
        dateTime: 1707919718170,
        classification: null,
        values: {
          LOC: "IPSROOM",
          STN: "VS",
          NAME: "BATT1",
          B1: 11021,
          B2: 11051,
          B3: 1000,
          B4: 9000,
          B5: 11021,
          B6: 11021,
          B7: 11021,
          B8: 11021,
          SUBGEAR: "SB1",
          GEARTYPE: "BAT",
          IBAT: 1000,
          VBAT: 43000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB2",
        dateTime: 1707919644886,
        classification: null,
        values: {
          LOC: "IPSROOM",
          B10: 11051,
          B11: 11021,
          B12: 121903,
          B13: "***",
          B14: "***",
          B15: "***",
          B16: "***",
          STN: "VS",
          NAME: "BATT2",
          B9: 10899,
          SUBGEAR: "SB2",
          GEARTYPE: "BAT",
          IBAT: -1000,
          VBAT: 15000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB1",
        dateTime: 1707919644537,
        classification: null,
        values: {
          LOC: "IPSROOM",
          STN: "VS",
          NAME: "BATT1",
          B1: 11021,
          B2: 11051,
          B3: 11051,
          B4: 11021,
          B5: 11021,
          B6: 11051,
          B7: 11021,
          B8: 11021,
          SUBGEAR: "SB1",
          GEARTYPE: "BAT",
          IBAT: 11000,
          VBAT: 23000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB2",
        dateTime: 1707919484722,
        classification: null,
        values: {
          LOC: "IPSROOM",
          B10: 5000,
          B11: 7000,
          B12: 121764,
          B13: "***",
          B14: "***",
          B15: "***",
          B16: "***",
          STN: "VS",
          NAME: "BATT2",
          B9: 1000,
          SUBGEAR: "SB2",
          GEARTYPE: "BAT",
          IBAT: 11000,
          VBAT: 16000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB1",
        dateTime: 1707919469203,
        classification: null,
        values: {
          LOC: "IPSROOM",
          STN: "VS",
          NAME: "BATT1",
          B1: 2021,
          B2: 6051,
          B3: 10021,
          B4: 9991,
          B5: 7021,
          B6: 6021,
          B7: 8021,
          B8: 4021,
          SUBGEAR: "SB1",
          GEARTYPE: "BAT",
          IBAT: 11000,
          VBAT: 1000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB2",
        dateTime: 1707919360263,
        classification: null,
        values: {
          LOC: "IPSROOM",
          B10: 1051,
          B11: 6021,
          B12: 121903,
          B13: "***",
          B14: "***",
          B15: "***",
          B16: "***",
          STN: "VS",
          NAME: "BATT2",
          B9: 10899,
          SUBGEAR: "SB2",
          GEARTYPE: "BAT",
          IBAT: 11000,
          VBAT: 67000,
        },
      },
    ],
  },
  {
    data: [
      {
        subGear: "SB1",
        dateTime: 1707919344824,
        classification: null,
        values: {
          LOC: "IPSROOM",
          STN: "VS",
          NAME: "BATT1",
          B1: 11021,
          B2: 11051,
          B3: 1021,
          B4: 1991,
          B5: 1021,
          B6: 5021,
          B7: 7021,
          B8: 8021,
          SUBGEAR: "SB1",
          GEARTYPE: "BAT",
          IBAT: 11000,
          VBAT: 66000,
        },
      },
    ],
  },
];
